import theme from '../../../lib/theme';
import { MultiSearchBlockProps } from './MultiSearchBlock';

const { layouts, scale, media, colors, font } = theme;
export default ({
  block: { desktop_background_image, mobile_background_image },
}: MultiSearchBlockProps) => ({
  container: {
    ...layouts.container,
    backgroundSize: 'cover !important',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '1rem',
    padding: `${scale.m} ${scale.xs}`,
    backgroundRepeat: 'no-repeat',
    background: `url(${
      mobile_background_image
        ? mobile_background_image
        : desktop_background_image
    }), rgba(0,0,0,0.5) no-repeat center center`,

    [media.m.up]: {
      padding: `${scale.xl} ${scale.m}`,
      background: `url(${desktop_background_image}), rgba(0,0,0,0.5) no-repeat center center`,
    },
  },

  subtitle: {
    color: colors.white,
    textAlign: 'center',
  },

  title: {
    color: colors.white,
    textAlign: 'center',
  },

  searchSourceTab: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.travel360.primary_dark,
    color: colors.white,
  },

  searchTabContentContainer: {
    marginTop: 0,
    backgroundColor: colors.white,
    padding: `${scale.xs} ${scale.m}`,
    boxShadow: '8px 11px 10px rgb(0 0 0 / 30%)',
    borderRadius: '1em',

    [media.l.down]: {
      padding: `${scale.xs} ${scale.s}`,
    },
  },

  searchTabstrip: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    '> *': {
      minWidth: '160px',
      padding: '0.75rem 2rem',
      borderRadius: '1rem 1rem 0 0',
      backgroundColor: colors.tas.primary,
      color: colors.white,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      [media.m.down]: {
        minWidth: 'unset',
        fontSize: font.s,
      },
    },

    'a': {
      color: colors.white,
      display: 'block',
      textDecoration: 'none',

      '&:hover': {
        color: colors.white,
      },
    },

    '> .active': {
      color: colors.travel360.primary_dark,
      backgroundColor: colors.white,
    },
  },
});
